import { useMemo } from 'react';

import { useCampaignLabels } from '../../../../hooks/queries';
import { useTranslation } from '../../../../hooks/useTranslation';
import { doesCampaignLabelMatchSearch } from './doesCampaignLabelMatchSearch';

type UseCampaignLabelOptionsProps = {
  search: string;
};

export const useCampaignLabelOptions = ({ search }: UseCampaignLabelOptionsProps) => {
  const { t } = useTranslation();
  const { campaignLabels, didError, isLoading } = useCampaignLabels();

  const options = useMemo(
    () =>
      campaignLabels
        .filter(({ id, name }) => doesCampaignLabelMatchSearch(name, id, search))
        .map((label) => ({
          title: label.name,
          subtitle: t('v2.conditionBuilder.campaignLabelSubtitle', { id: label.id }),
          value: label.id.toString(),
        }))
        .sort(({ title: a }, { title: b }) => a.localeCompare(b)),
    [campaignLabels, t, search],
  );

  return { options, didError, isLoading };
};
